import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';

import Loader from '../components/Loader';

import useFetchDommages from '../hooks/useFetchDommages';
import useFetchSites from '../hooks/useFetchSites';
import useFetchDeclarations from '../hooks/useFetchDeclarations';
// import useFetchDoxExt from '../hooks/useFetchDoxExt';
// import useFetchDocs from '../hooks/useFetchDocs';

import { formatDate, formatCurrency } from '../utils/Format';
import AutoResizeTextarea from '../utils/AutoResizeTextarea';

import SectionCard from '../utils/SectionCard';
import InfoItem from '../utils/InfoItem';

const Row = ({ children }) => (
    <div className="gap-6 grid grid-cols-1 lg:grid-cols-2">{children}</div>
);

const DommageDetails = () => {
    const { uuid } = useParams();

    const { dommage, fetchDommageByUUID, loading } = useFetchDommages();
    const { site: siteDommage, fetchSiteByUUID } = useFetchSites();
    const { declaration: declaDommage, fetchDeclarationByUUID } = useFetchDeclarations();

    const [activeTab, setActiveTab] = useState('coord');

    const [openSettings, setOpenSettings] = useState(false);
    const settingsBtnRef = useRef(null);
    const settingsMenuRef = useRef(null);

    useEffect(() => {
        if (uuid) {
            fetchDommageByUUID(uuid);
        }
    }, [uuid]);

    useEffect(() => {
        if (dommage && dommage.UUID_Declaration_) {
            fetchDeclarationByUUID(dommage.UUID_Declaration_);
        }
    }, [dommage]);

    useEffect(() => {
        if (declaDommage && declaDommage.UUID_Site_) {
            fetchSiteByUUID(declaDommage.UUID_Site_);
        }
    }, [declaDommage]);

    useEffect(() => {
        if (!openSettings) return;

        const handleClickOutside = (e) => {
            const btn = settingsBtnRef.current;
            const menu = settingsMenuRef.current;

            if (btn?.contains(e.target)) return;
            if (menu?.contains(e.target)) return;

            setOpenSettings(false);
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [openSettings]);

    if (!dommage || !declaDommage || !siteDommage) {
        return <div class="flex flex-1 justify-center items-center"><Loader /></div>;
    }

    // console.log("Dommage chargé:", dommage);
    // console.log("Site chargé:", siteDommage);
    // console.log("Déclaration chargé:", declaDommage);

    return (

        <div class="flex-1 p-4 lg:p-8">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12">
                        <div className="mb-4 w-full rounded-xl bg-gray-900/95 px-5 py-3 shadow-lg sm:px-7 sm:py-4">
                            <nav
                                id="url"
									className="flex items-center gap-2 text-xs font-semibold text-slate-300 sm:text-sm mb-2"
                            >
                                <Link
                                    to="/sites"
                                    className="hover:text-white decoration-orange-500 hover:underline hover:underline-offset-2 transition hover:translate-y-[-1px] duration-200"
                                >
                                    Sites
                                </Link>
                                <span className="cursor-default text-orange-100/70">/</span>

                                <Link
                                    to={`/sites/${siteDommage.UUID_}`}
                                    className="hover:text-white decoration-orange-500 hover:underline hover:underline-offset-2 transition hover:translate-y-[-1px] duration-200"
                                >
                                    {siteDommage.Nom}
                                </Link>
                                <span className="cursor-default text-orange-100/70">/</span>

                                <Link
                                    to="/declarations"
                                    className="hover:text-white decoration-orange-500 hover:underline hover:underline-offset-2 transition hover:translate-y-[-1px] duration-200"
                                >
                                    Déclarations
                                </Link>
                                <span className="cursor-default text-orange-100/70">/</span>

                                <Link
                                    to={`/declarations/${declaDommage.UUID_}`}
                                    className="hover:text-white decoration-orange-500 hover:underline hover:underline-offset-2 transition hover:translate-y-[-1px] duration-200"
                                >
                                    {declaDommage.Libelle
                                        ? `${declaDommage.Libelle.slice(0, 30)}${declaDommage.Libelle.length > 50 ? '…' : ''
                                        }`
                                        : 'Sans Libelle'}
                                </Link>
									<span className="cursor-default text-slate-500">/</span>
									<span className="inline-flex items-center text-orange-400">
                                    {dommage.Libelle_Court
                                        ? `${dommage.Libelle_Court.slice(0, 30)}${dommage.Libelle_Court.length > 50 ? '…' : ''
                                        }`
                                        : 'Sans Libelle'}
                                </span>
                            </nav>

                            <div className="mt-3 flex items-center justify-between gap-3">
                                <div className="flex flex-wrap items-center gap-3">
                                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-tr from-orange-500 via-orange-400 to-amber-300 shadow-sm shadow-orange-500/40">
                                        <i className="fa-solid fa-house-crack text-white/90 text-lg" />
                                    </span>

                                    <h1 className="flex flex-wrap items-center gap-3 font-bold text-xl sm:text-2xl leading-none text-white">
                                        <span>Dommage</span>

                                        <span className="flex items-center gap-2 text-sm sm:text-base text-orange-300">
                                            {dommage?.CODE_CRAC && (
                                                <>
                                                    <i className="fa-solid fa-hashtag" />
                                                    <span className="uppercase">{dommage.CODE_CRAC}</span>
                                                </>
                                            )}

                                            {dommage?.Etat && (
                                                <span className="font-bold text-white">
                                                    ({dommage.Etat})
                                                </span>
                                            )}
                                        </span>
                                    </h1>
                                </div>

                                <div className="relative">
                                    <button
                                        ref={settingsBtnRef}
                                        type="button"
                                        title="Paramètres"
                                        aria-label="Paramètres"
                                        disabled={loading}
                                        onClick={() => setOpenSettings(v => !v)}
                                        className="group inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white/10 text-gray-100 hover:bg-white/20 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-white/60 transition"
                                    >
                                        <i className="fa-solid fa-gear group-hover:rotate-[20deg] transition-transform duration-200" />
                                    </button>

                                    {openSettings && (
                                        <div
                                            ref={settingsMenuRef}
                                            className="absolute right-0 mt-2 w-48 rounded-lg bg-white py-1 text-sm text-gray-700 shadow-lg ring-1 ring-black/5 z-50"
                                        >
                                            <Link
                                                to={`/dommages/edit/${uuid}`}
                                                state={{ dommage }}
                                                onClick={() => setOpenSettings(false)}
                                                className="flex w-full items-center gap-2 px-3 py-2 hover:bg-gray-100"
                                            >
                                                <i className="fa-solid fa-pen" />
                                                <span>Modifier le dommage</span>
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>



                        <div className="mb-1 border-gray-200 dark:border-gray-700 border-b">
                            <ul className="flex flex-wrap -mb-px" role="tablist">
                                {[
                                    { id: 'coord', label: 'Coordonnées' },
                                    // { id: 'dommages', label: 'Dommages' },
                                    // { id: 'exp', label: 'Expertises' },
                                    // { id: 'docs', label: 'Documents Externes' },
                                ].map((tab) => (
                                    <li key={tab.id} className="mr-2" role="presentation">
                                        <button
                                            className={`text-base font-semibold text-center py-4 px-4 rounded-t-lg border-b-5 ${activeTab === tab.id
                                                ? 'text-orange-600 borde-2 border-orange-300 dark:text-white'
                                                : 'text-orange-400 border-transparent hover:text-orange-500'
                                                } transition duration-300 ease-in-out`}
                                            onClick={() => setActiveTab(tab.id)}
                                            type="button"
                                            role="tab"
                                            aria-controls={tab.id}
                                            aria-selected={activeTab === tab.id}
                                        >
                                            {tab.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div id="myTabContent">
                            {activeTab === 'coord' && (
                                <div id="form-info" className="space-y-6 mx-auto">


                                    {/* LIGNE 1 : Rappels Site / Rappels Déclaration */}
                                    <Row>
                                        <SectionCard title="Rappels Site" icon="fa-building">
                                            <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                <InfoItem label="Site Nom" value={siteDommage?.Nom} />
                                                <InfoItem label="Entité / Région" value={siteDommage?.Entite} />
                                                <InfoItem label="Société" value={siteDommage?.Societe} />
                                                <InfoItem label="Domaine d’activité" value={siteDommage?.Etat} />
                                                <InfoItem label="Code compta" value={siteDommage?.Code_compta} mono />
                                                <InfoItem label="Date OS" value={formatDate(siteDommage?.Date_OS)} />
                                                <InfoItem label="Date DOC" value={formatDate(siteDommage?.Date_DOC)} />
                                                <InfoItem label="P.V. Réception" value={formatDate(siteDommage?.Date_PVRecep)} />
                                            </div>
                                        </SectionCard>

                                        <SectionCard title="Rappels Déclaration" icon="fa-file-shield">
                                            <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                <InfoItem label="Libellé" value={declaDommage?.Libelle} />
                                                <InfoItem label="Type" value={declaDommage?.Type_Declaration} />
                                                <InfoItem label="Code" value={declaDommage?.Code_Procedure} mono />
                                                <InfoItem label="État" value={declaDommage?.Etat} />
                                                <InfoItem label="Création" value={formatDate(declaDommage?.Date_creation)} />
                                            </div>
                                        </SectionCard>
                                    </Row>

                                    {/* LIGNE 2 : Détails / Pathologies */}
                                    <Row>
                                        <SectionCard title="Détails du Dommage" icon="fa-circle-info">
                                            <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                <InfoItem label="Libellé" value={dommage?.Libelle_Court} />
                                                <InfoItem label="Code CRAC" value={dommage?.CODE_CRAC} mono />
                                                <InfoItem label="Type de Risque" value={dommage?.Type_Risque} />
                                                <InfoItem label="État" value={dommage?.Etat} />
                                                <InfoItem label="Date de création" value={formatDate(dommage?._Date_Crea)} />
                                            </div>
                                        </SectionCard>

                                        <SectionCard title="Pathologies identifiées" icon="fa-stethoscope">
                                            <div className="gap-2 grid grid-cols-1">
                                                <ul className="pl-5 list-disc">
                                                    {[...Array(6).keys()].map(i => {
                                                        const k = `Cd_Patho_${i + 1}`;
                                                        return dommage?.[k] ? <li key={k}>{dommage[k]}</li> : null;
                                                    })}
                                                </ul>
                                            </div>
                                        </SectionCard>
                                    </Row>

                                    {/* LIGNE 3 : Récapitulatif financier / Intervenants */}
                                    <Row>
                                        <SectionCard title="Récapitulatif financier" icon="fa-scale-balanced">
                                            <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                <InfoItem label="Provision Totale" value={formatCurrency(dommage?.Provision_TT)} />
                                                <InfoItem label="Recours Total" value={formatCurrency(dommage?.Recours_TT)} />
                                            </div>
                                        </SectionCard>

                                        <SectionCard title="Intervenants & Références" icon="fa-user-tie">
                                            <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                <InfoItem label="Intervenant" value={dommage?.Intervenant_Nom || "N/A"} />
                                            </div>
                                        </SectionCard>
                                    </Row>

                                    {/* LIGNE 4 : Recours & Règlements */}
                                    <SectionCard title="État du recours & règlements" icon="fa-file-invoice-dollar">
                                        <div className="gap-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                                            <InfoItem label="Recours Prévu" value={formatCurrency(dommage?.Recours_PP)} />
                                            <InfoItem label="Règlement" value={formatCurrency(dommage?.Reglement)} />
                                            <InfoItem label="Règlement Date" value={formatDate(dommage?.Reglement_Date)} />
                                            <InfoItem label="Quitus Transmis" value={dommage?.Quitus_Transmis ? "Oui" : "Non"} />
                                        </div>
                                    </SectionCard>
                                </div>
                            )}
                            {/* {activeTab === 'dommages' && (
									<ListDommage lstDommages={dommages}/>
								)}
								{activeTab === 'exp' && (
									<ListDoc lstDocs={lstDocs} type="Expertise"/>
								)} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

};

export default DommageDetails;